import { Component } from '@angular/core';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(private readonly lsService : SessionStorageService) { }

  cleartype(){
    this.lsService.getLSItem("type")
  }

}


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterMainComponent {

  constructor(private readonly lsService : SessionStorageService) { }

  cleartype(){
    this.lsService.getLSItem("type")
  }

}
